module.exports = __webpack_public_path__ + "3c35a6c2973aae0f4bd5115c4fe25b61.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/p28.png
// module id = 498
// module chunks = 0